
import { useState } from 'react';

export const useUserForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    role: 'staff' as 'admin' | 'manager' | 'staff'
  });

  const resetForm = () => {
    setFormData({ email: '', password: '', full_name: '', role: 'staff' });
  };

  const setFormDataForEdit = (user: any) => {
    setFormData({
      email: user.email || '',
      password: '',
      full_name: user.full_name,
      role: user.role
    });
  };

  return {
    formData,
    setFormData,
    resetForm,
    setFormDataForEdit
  };
};
